import { Navigate } from 'react-router-dom';

import { useEu } from '@/dados';

/* A guarda das telas do painel.
 *
 * É COMODIDADE, não segurança: quem não é admin recebe 404 em toda rota do
 * painel, e a API é quem garante isso. Esconder a tela existe para não
 * oferecer um caminho que não leva a lugar nenhum.
 *
 * Mora num arquivo próprio porque são duas telas (a lista e a empresa) e a
 * segunda, aberta por endereço direto, é justamente a que alguém esqueceria
 * de proteger. */
export function SoAdmin({ children }: { children: React.ReactNode }) {
  const eu = useEu();
  if (eu.isPending) return null;
  if (eu.data?.papel !== 'admin') return <Navigate to="/" replace />;
  return <>{children}</>;
}
